import { render, staticRenderFns } from "./ProductPackageHorizontalContent.vue?vue&type=template&id=24d2a3b0&scoped=true"
import script from "./ProductPackageHorizontalContent.vue?vue&type=script&lang=js"
export * from "./ProductPackageHorizontalContent.vue?vue&type=script&lang=js"
import style0 from "./ProductPackageHorizontalContent.vue?vue&type=style&index=0&id=24d2a3b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d2a3b0",
  null
  
)

export default component.exports